// ironclad.js — shared, site-wide behavior. Page-specific logic (custom-work pricing,
// card search) lives in its own asset and is loaded only on the templates that need it.

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.getElementById('ic-menu-toggle');
  const mobileMenu = document.getElementById('ic-mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }
});
